<template>
  <div class="login">
    <div class="login-time">
      {{ time }}
    </div>
    <div class="login-message">
      <div class="title">
        <img src="../assets/index2.png" alt="" />
      </div>
      <div class="form">
        <el-form
          label-position="top"
          label-width="80px"
          :model="loginForm"
          :rules="rules"
          ref="form"
        >
        <el-form-item prop="userName">
          <el-select
            v-model="loginForm.userName"
            placeholder="请输入账号"
            style="width: 100%;"
          >
            <template #prefix>
              <div class="inco-left">
                <img src="../assets/login2.png" alt="" />
              </div>
            </template>
            <el-option
              v-for="item in userData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="请输入密码"
              style="width: 100%;margin-top:10px  "
            >
              <template #prefix>
                <div class="inco-left">
                  <img src="../assets/login3.png" alt="" />
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="btn">
          <el-button @click="loginSubmit">登录</el-button>
        </div>
      </div>
    </div>
    <div class="login-footer">
      Copyright © 2009-2023 厦门鸿宁兴科技有限公司 版权所有
      闽ICP备2021010477号-1
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      time: "",
      loginForm: {
        userName: "",
        password: "",
      },
      userData: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      rules: {
        userName: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getTime();

    setInterval(() => {
      this.getTime();
    }, 1000);
  },
  methods: {
    getTime() {
      this.time = this.$dayjs().format("YYYY年MM月DD日 HH:mm:ss");
    },
    loginSubmit(){
       this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('success')
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url("../assets/login1.png") no-repeat center center;
  background-size: cover;
  position: relative;
  .login-time {
    position: absolute;
    left: 3.125rem;
    top: 3.125rem;
    width: 100%;
    color: #fff;
    opacity: 0.9;
    font-size: 1.125rem;
    overflow: hidden;
    font-weight: bold;
  }
  // .aa {
  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }
  .login-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 28.75rem;
    // height: 27.5rem;
    background: #ffffff;
    border-radius: 0.9375rem;
    padding: 1.25rem 0;
    .title {
      display: flex;
      justify-content: center;
      padding: 1.875rem 0 1.25rem 0;
      img {
        width: 16.25rem;
        height: 100%;
      }
    }
    .form {
      padding: 0 1.875rem;
      .inco-left {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: .3125rem;
        img{
          width: 1.0625rem;
          height: 1.0625rem;
        }
      }
      .btn {
        .el-button {
          width: 100%;
          margin-top: 3.75rem;
          background: linear-gradient(-80deg, #136afb 0%, #2b9efc 100%);
          border-radius: 0.5rem;
          font-size: 1.25rem;
          font-weight: 500;
          color: #ffffff;
          border: 0;
        }
      }
    }
  }
  .login-footer {
    position: absolute;
    left: 50%;
    bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    transform: translate(-50%, 0);
  }
}
:deep(.el-form-item){
  margin-bottom: 10px !important;
}

:deep(.el-input__inner::-webkit-input-placeholder){
  font-size: 14px;
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  // .login-message{
  //   width: 500px;
  //   height: 300px;
  // }
}